<template>
  <v-popover
    style=".trigger{width: 100%}"
    offset="4"
    :open="show_filter"
  >
    <div @click="show_filter = !show_filter" class="unselectable" style="cursor: pointer">
      <div>
        {{ selectedLang.label }}
      </div>
    </div>

    <template
      slot="popover">
      <ul class="select2-results__options col-12">
        <div class="col-12">
        </div>
        <li
          v-for="language of languages"
          @click="setLanguage(language)"
          :class="{'activeItem': selectedLang.short === language.short}"
          style="cursor: pointer"
          class="select2-results__option select2-results__option--highlighted p-1"
          :key="language.label"
        >
          <div class="col-12">
            {{ language.label }}
          </div>

        </li>
      </ul>
    </template>
  </v-popover>
</template>

<script>
  import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';
  import { mapGetters } from 'vuex';
  import moment from 'moment';
  export default {
    name: 'languageSwitcher',
    components: {
      'v-popover': VPopover,
    },
    directives: {
      tooltip: VTooltip,
      'close-popover': VClosePopover,
    },
    methods: {
      setLanguage (language) {
        this.$i18n.locale = language.short;
        this.account.lang = language.short;
        this.$store.dispatch('updateAccount', this.account);
        this.selectedLang = language;
        this.show_filter = false;
        if (language.short === 'en') {
          moment.locale('en-ie');
        } else {
          moment.locale('ru');
        }
      },
    },
    data () {
      return {
        show_filter: false,
        selectedLang: '',
        languages: [
          {
            short: 'en',
            label: 'English 🇺🇸',
          },
          {
            short: 'ru',
            label: 'Russian 🇷🇺',
          },
        ],
      };
    },
    computed: {
      ...mapGetters([
        'account',
      ]),
    },
    mounted () {
      if (this.account) {
        const selected = this.account.lang;
        for (const lang of this.languages) {
          if (lang.short === selected) {
            this.selectedLang = lang;
          }
        }
      } else {
        this.selectedLang = 'en';
      }
    },
  };
</script>

<style scoped>
  .v-popover{
    text-align: center;
  }

  .activeItem {
    color: #35A666 !important;
  }
</style>
